export default {
    namespaced: true,

    state: {
        view: false,
        title: "",
        text: "",
        type: "",
        callback: null,
    },

    actions: {
        open({ commit }, data) {
            commit("view", data);
        },

        close({ commit }) {
            commit("close");
        },
    },

    mutations: {
        view(state, { title, text, type, callback }) {
            state.view = true;
            state.title = title;
            state.text = text;
            state.type = type;
            state.callback = callback;
        },

        close(state) {
            state.view = false;
        },
    },
};
